	import Cookies from 'js-cookie'

export const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const hasPermission = (permissionName) => {
  const permissionsCookie = Cookies.get('Permissons')

  if (!permissionsCookie) return false

  try {
    const permissionArray = JSON.parse(permissionsCookie)
    if (!Array.isArray(permissionArray)) return false
    if (permissionArray.includes('*')) return true
    return permissionArray.some(
      (p) => String(p).toLowerCase() === String(permissionName).toLowerCase()
    )
  } catch (_) {
    return false
  }
}

export const formatTime12Hour = (time24) => {
  if (!time24) return "";

  // Expected formats: "14:30" or "14:30:00"
  const [hourStr, minute] = time24.split(":");
  let hour = parseInt(hourStr, 10);

  const ampm = hour >= 12 ? "PM" : "AM";
  hour = hour % 12 || 12; // 0 => 12

  return `${hour}:${minute} ${ampm}`;
};

export const cleanObject = (obj) => {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) =>
      value !== undefined &&
      value !== null &&
      value !== ""
    )
  );
};

export const asEntityId = (value) => {
  if (value == null || value === "") return "";
  if (typeof value === "string" || typeof value === "number") return String(value);
  if (typeof value === "object") {
    if (value._id) return asEntityId(value._id);
    if (value.id) return asEntityId(value.id);
    if (typeof value.toHexString === "function") return value.toHexString();
    if (typeof value.toString === "function") {
      const asString = value.toString();
      if (asString && asString !== "[object Object]") return asString;
    }
  }
  return "";
};

/** True after an admin password reset, until the user sets their own password. */
export const mustChangePassword = () => Cookies.get('ClmustChangePassword') === 'true';

/** True when the logged-in user is an admin (role cookie set at login). */
export const isAdmin = () =>
  String(Cookies.get('Clrole') || '').toLowerCase() === 'admin';

export const canAssignStaff = (role) => {
  const value = String(role || "").toLowerCase();
  return value === "admin" || value === "manager";
};

export const getIdNameIfAdmin = (data) => {
    if(canAssignStaff(data?.role)) {
      return null;
    }
  return {
    _id: data?.EmployeeId || "",
    name: data?.firstName || "",
  };
};  